import { LOAD_JOB_LOG } from "../actions/job";

export default function(state = [], action) {
  switch (action.type) {
    case LOAD_JOB_LOG:
      console.log("Job Log Reducer");
      console.log(action);
      if (action.payload ==""){
        let log = {};
        log["event_list"]=null;
        return log;
      }
      return action.payload;
    default:
      return null;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/job_log.js